export default __webpack_public_path__ + "4d7e9de6d59268f3c24268c9ce02891e.png";